import { render, staticRenderFns } from "./DeliveryComplete.vue?vue&type=template&id=7ba9d2f6&"
import script from "./DeliveryComplete.vue?vue&type=script&lang=js&"
export * from "./DeliveryComplete.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryComplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports